import * as yup from "yup";
import { es } from 'yup-locales';
yup.setLocale(es);

export default yup